import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Heading } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { getOffices } from "../../features/location/officeSlice";
import OfficeList from "../components/OfficeList";
import { addStudent } from "../../features/students/studentSlice";
import { Formik, Form } from "formik";
import { SHARED_ROUTES } from "../../config/routes";
import * as Yup from 'yup';

const Booking = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { offices: officeList } = useSelector((state) => state.office || {});
  const [date, setDate] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const params = {
    date: searchParams.get("weekStartingDate"),
    locationID: searchParams.get("locationId")
  };

  const [selectedValue, setSelectedValue] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedGenderValue, setSelectedGenderValue] = useState(null);

  const handleSelectedSchoolChange = (school) => {
    setSelectedValue(school);
  }

  const handleSelectedGenderChange = (gender) => {
    setSelectedGenderValue(gender);
  };

  const initialValues = {
    studentEmail: "",
    studentName: "",
    school: "",
    gender: "",
    guardian_email_address: "",
    isConsentGranted: false,
    guardianName: "",
    iceContactNumber: "",
    altIceContactNumber: "",
    medicalConditions: "",
    tyInfoSource: "",
    questions: "",
    isAllowedLDL: false,
    isAllowedPB: false,
    location_id: params.locationID || officeList?.[0]?.location_id || 0,
    week_starting_date: params.date || "",
  }

  const SignupSchema = Yup.object().shape({
    studentEmail: Yup.string().email('Invalid email').required('Student Email is Required'),
    studentName: Yup.string().required('Student Name is Required'),
    school: Yup.object().nullable().required('Required'),
    guardian_email_address: Yup.string().email('Invalid email').required('Guardian Email Address is Required'),
    isConsentGranted: Yup.boolean().oneOf([true], 'Consent input is required'),
    guardianName: Yup.string().required('Guardian Name is Required'),
    iceContactNumber: Yup.string().required('Emergency contact is Required'),
  });


  useEffect(() => {
    dispatch(getOffices())
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          return response;
        } else {
          throw response.payload;
        }
      })
      .catch((error) => {
        console.error("GetOffices Dispatch ", error);
      });
  }, [dispatch]);

  const handleSubmitClick = () => {
    setFormSubmitted(true);
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  const onSubmit = (e) => {
    // setFormSubmitted(true);
    /*
      Expected input:
      {
        studentEmail: "",
        studentName: "",
        school: "",
        guardian_email_address: "",
        isConsentGranted: false,
        guardianName: "",
        iceContactNumber: "",
        altIceContactNumber: "",
        medicalConditions: "",
        tyInfoSource: "",
        questions: "",
        isAllowedLDL: false,
        locationId: location_id,
        bookingDate: bookingDateId,
      }
    */
    dispatch(addStudent({
      ...e,
      bookingDate: date,
      locationId: e.location_id,
      school: selectedValue,
      gender: selectedGenderValue,
    }))
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          navigate(SHARED_ROUTES.home);
        } else {
          throw response.payload;
        }
      })
      .catch((error) => {
        const startIndex = error.data.indexOf('"errorMessage": "') + '"errorMessage": "'.length;
        const endIndex = error.data.indexOf('"}:', startIndex);
        // Extract the error message
        const errorMessage = error.data.substring(startIndex, endIndex);
        console.error("Add student dispatch ", error);
        window.alert(errorMessage);
      });
  };

  return (
    <Box maxWidth="1300px" margin="auto" className="responsive-page-content">
      <Link to={SHARED_ROUTES.home}>
        <Button as="span" leftIcon={<ArrowBackIcon />} colorScheme="red" variant="link" mb="0.7em" onClick={handleGoBack}>
          Back
        </Button>
      </Link>
      <Box bg="white" border="1px solid #edebe9" padding="1em 2.5em 4em 2.5em">
        <Heading as="h2" size="md" textAlign="center" mb="1.5em" mt="0.5em">
          Booking Form
        </Heading>
        {officeList.length ? (
          <Formik onSubmit={onSubmit} id="booking-form" initialValues={initialValues} validationSchema={SignupSchema} >
            {(props) => (
              <Form>
                <Box margin="auto" maxWidth="800px">
                  {officeList.length > 0 ? (
                    <OfficeList
                      onSelectedSchoolChange={handleSelectedSchoolChange}
                      onSelectedGenderChange={handleSelectedGenderChange}
                      officeLocations={officeList}
                      onDateUpdate={setDate}
                      formik={formSubmitted === true ? props : null}
                    />
                  ) : (
                    <></>
                  )}
                  {date && (
                    <Box mt="1.5em" textAlign="center" mb="3em">
                      <Button
                        colorScheme="red"
                        type="submit" // Change type to button to prevent form submission
                        width="300px"
                        onClick={handleSubmitClick}
                        isDisabled={!props.isValid}
                      >
                        Book
                      </Button>
                      {/* Show validation errors if form has been submitted and is invalid */}
                      {formSubmitted && !props.isValid && (
                        <Box mt="1em" color="red">
                          Please fill the required fields
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Form>
            )}
          </Formik>
        ) : (
          'Error loading office list'
        )}

      </Box>
    </Box>
  );
};

export default Booking;
